/** @jsx jsx */
import { jsx } from '@emotion/core';
import style from './style';
import utils from '../../../utils';
import ImageGallery from 'react-image-gallery';
import FsLightbox from 'fslightbox-react';
import { useState, useEffect } from 'react';
import { createPortal } from "react-dom";

function Portal({ children }) {
  const [el] = useState(document.createElement('div'));
  useEffect(() => {
    let mount = document.getElementById("portal-root");
    mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el]);
  return createPortal(children, el);
}

export function PhotoSlide(props) {
  const item = props.item;
  const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  const cssClass = utils.classNames(
    'cms_item',
    'photoSlide',
    item.cssClass || item.anchorName || ''
  );
  const images = [];
  subItems.map((subItem, index) => {
    subItem.payloads[0].value.split('|').map((value, index) => {
      images.push({
        original: value,
        thumbnail: value,
      });
      return null;
    });
    return null;
  });
  const [toggler, setToggler] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const _handleClick = (event) => {
    setImageUrl(event.target.src);
    console.log(imageUrl);
    setToggler(!toggler);
  };

  return (
    <div
      css={style.photoSlide}
      className={cssClass}
      data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
      id={item.anchorName}
    >
      <Portal>
        <FsLightbox
          toggler={toggler}
          sources={[imageUrl]}
          disableBackgroundClose={true}
        />
      </Portal>
      <ImageGallery
        items={images}
        slideInterval={2000}
        showFullscreenButton={false}
        onClick={_handleClick}
      />
    </div>
  );
}
